import { render, staticRenderFns } from "./holiday-table.vue?vue&type=template&id=2c9e79d9&scoped=true&"
import script from "./holiday-table.ts?vue&type=script&lang=ts&"
export * from "./holiday-table.ts?vue&type=script&lang=ts&"
import style0 from "./holiday-table.scss?vue&type=style&index=0&id=2c9e79d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e79d9",
  null
  
)

export default component.exports